import { NavigationHistoryService } from './shared/services/navigation-history.service';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    navigationHistoryService: NavigationHistoryService) { }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => {
        if (event instanceof NavigationEnd) {
          if ((<any>window).ga) {
            (<any>window).ga('set', 'page', event.urlAfterRedirects.split('?')[0]);
            (<any>window).ga('send', 'pageview');
          }
          return true;
        }
        return false;
      }))
      .pipe(map(() => this.activatedRoute))
      .pipe(map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(switchMap(route => route.data))
      .subscribe((event: any) => {
        this.titleService.setTitle(event?.title || 'SpotPass');
        const tip = document.querySelector('.ss-hover-tip');
        if (tip) {
          tip.parentNode?.removeChild(tip);
        }
      });

  }
}
